import React, { useEffect, useRef, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import moment from "moment/moment";
import { isEmpty, isEqual, startCase } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { formatWithCommas } from "../../Utils/Toast";
import TransactionRecordDetail from "./TransactionRecordDetail";
import TransactionRecordFilter from "./TransactionRecordFilter";
import NoData from "../../component/NoData";
const TransactionRecords = () => {
  var previousDate = moment().subtract(6, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [detail, setDetail] = useState({});
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    // status: "",
    payment: "all",
    date: "today",
    fromPeriod: previousDate,
    toPeriod: currentDate,
  });
  const [object, setObject] = useState({
    Withdrawalaccepted: 0,
    Withdrawalrejected: 0,
    Depositaccepted: 0,
    Depositrejected: 0,
  });
  const prevFilterRef = useRef(filter);
  const groupByUpdatedDateWithBets = (arr) => {
    // Sort by updatedAt descending (latest first)
    const sorted = arr.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
    );

    // Group by date
    let grouped = sorted.reduce((acc, item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0]; // YYYY-MM-DD

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(item);
      return acc;
    }, {});

    return Object.entries(grouped).map(([date, markets]) => ({
      date,
      markets,
    }));
  };

  const getData = async () => {
    try {
      let finalData = [];

      if (filter?.payment == "withdrawal") {
        // Only withdrawal API
        const withdrawRes = await apiGet(apiPath.withDrawHistory, {
          fromPeriod: filter?.fromPeriod,
          toPeriod: filter?.toPeriod,
        });

        finalData =
          withdrawRes?.status === 200 && withdrawRes?.data?.success
            ? withdrawRes.data.results
            : [];

        setObject({
          Withdrawalaccepted:
            withdrawRes?.data?.results
              ?.filter((item) => item?.status == "completed")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
          Withdrawalrejected:
            withdrawRes?.data?.results
              ?.filter((item) => item?.status == "declined")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
        });
      } else if (filter?.payment == "deposit") {
        // Only deposit API
        const depositRes = await apiGet(apiPath.depositHistory, {
          fromPeriod: filter?.fromPeriod,
          toPeriod: filter?.toPeriod,
        });

        finalData =
          depositRes?.status === 200 && depositRes?.data?.success
            ? depositRes.data.results
            : [];

        setObject({
          Depositaccepted:
            depositRes?.data?.results
              ?.filter((item) => item?.status == "completed")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
          Depositrejected:
            depositRes?.data?.results
              ?.filter((item) => item?.status == "declined")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
        });
      } else {
        // Both APIs (no filter or 'all')
        const [depositRes, withdrawRes] = await Promise.all([
          apiGet(apiPath.depositHistory, {
            fromPeriod: filter?.fromPeriod,
            toPeriod: filter?.toPeriod,
          }),
          apiGet(apiPath.withDrawHistory, {
            fromPeriod: filter?.fromPeriod,
            toPeriod: filter?.toPeriod,
          }),
        ]);

        const depositData =
          depositRes?.status === 200 && depositRes?.data?.success
            ? depositRes.data.results
            : [];

        const withdrawData =
          withdrawRes?.status === 200 && withdrawRes?.data?.success
            ? withdrawRes.data.results
            : [];
        finalData = [...depositData, ...withdrawData];
        setObject({
          Withdrawalaccepted:
            withdrawRes?.data?.results
              ?.filter((item) => item?.status == "completed")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
          Withdrawalrejected:
            withdrawRes?.data?.results
              ?.filter((item) => item?.status == "declined")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
          Depositaccepted:
            depositRes?.data?.results
              ?.filter((item) => item?.status == "completed")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
          Depositrejected:
            depositRes?.data?.results
              ?.filter((item) => item?.status == "declined")
              ?.reduce((acc, item) => acc + item.amount, 0) || 0,
        });
      }

      const grouped = groupByUpdatedDateWithBets(finalData);
      setData(grouped);
    } catch (error) {}
  };
  // useEffect(() => {
  //   if (!isEqual(prevFilterRef.current, filter)) {
  //     prevFilterRef.current = filter;
  //     getData();
  //   }
  // }, [filter]);
  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);

  console.log(object, "datat");

  return (
    <AccountLayout title={t("TransactionRecords")}>
      <TransactionRecordFilter
        setFilter={setFilter}
        filter={filter}
        getData={getData}
      />

      <div
        _ngcontent-serverapp-c3748548866
        className="transaction-record-list ng-tns-c3748548866-17 ng-star-inserted"
      >
        {" "}
        <div
          style={{ margin: "10px", width: "95%", borderRadius: "8px" }}
          className="player-top player-withdraw ng-tns-c2278473435-17"
        >
          <div className="main-wallet-info ng-tns-c2278473435-17">
            {["withdrawal", "all"].includes(filter?.payment) && (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    Total Withdrawal Accepted:{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    {object.Withdrawalaccepted}
                  </span>
                </div>{" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    Total Withdrawal Rejected:{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    {object.Withdrawalrejected}
                  </span>
                </div>{" "}
              </>
            )}
            {["deposit", "all"].includes(filter?.payment) && (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    Total Deposit Accepted:{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    {object.Depositaccepted}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    Total Deposit Rejected:{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    {object.Depositrejected}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
        <div
          _ngcontent-serverapp-c3748548866
          className="list-title ng-tns-c3748548866-17"
        >
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field type ng-tns-c3748548866-17"
          >
            {t("Type")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field amount ng-tns-c3748548866-17"
          >
            {t("Amount")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field status ng-tns-c3748548866-17"
          >
            {t("Status")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field time ng-tns-c3748548866-17"
          >
            {t("Time")}
          </div>
        </div>
        <app-waterfall-scroll
          _ngcontent-serverapp-c3748548866
          _nghost-serverapp-c302379289
          className="ng-tns-c3748548866-17 ng-star-inserted"
        >
          {data?.length > 0 ? (
            data?.map((res) => {
              return (
                <div
                  _ngcontent-serverapp-c3748548866
                  className="list-group ng-tns-c3748548866-17 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="date-title ng-tns-c3748548866-17"
                  >
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="date ng-tns-c3748548866-17"
                    >
                      <i
                        _ngcontent-serverapp-c3748548866
                        className="ng-tns-c3748548866-17"
                        style={{
                          "mask-image":
                            'url("/assets/Other/icon-calendar-type02.svg")',
                        }}
                      />
                      {res?.date}
                    </div>
                    <div
                      _ngcontent-serverapp-c3748548866
                      className="time-zone ng-tns-c3748548866-17"
                    >
                      {" "}
                      GMT+5.5{" "}
                    </div>
                  </div>
                  <ul
                    _ngcontent-serverapp-c3748548866
                    className="list-content ng-tns-c3748548866-17 ng-trigger ng-trigger-staggerFadeAnimation"
                  >
                    {res?.markets?.map((item) => {
                      return (
                        <li
                          onClick={() => setDetail(item)}
                          _ngcontent-serverapp-c3748548866
                          className="ng-tns-c3748548866-17 ng-star-inserted"
                          idx="D843638176"
                        >
                          <div
                            _ngcontent-serverapp-c3748548866
                            className="list-field type ng-tns-c3748548866-17"
                          >
                            {startCase(item?.type)}
                          </div>
                          <div
                            _ngcontent-serverapp-c3748548866
                            className="list-field amount ng-tns-c3748548866-17"
                          >
                            <i
                              id="locale-util-dicrective-1"
                              className="ng-tns-c3748548866-17"
                              style={{ display: "initial" }}
                            >
                              {formatWithCommas(item?.amount)}
                            </i>
                          </div>
                          <div
                            _ngcontent-serverapp-c3748548866
                            className={`list-field ng-tns-c3748548866-17 ${
                              item?.status == "completed"
                                ? "status-positive"
                                : "status-negative"
                            } `}
                          >
                            <div
                              _ngcontent-serverapp-c3748548866
                              className="tags ng-tns-c3748548866-17"
                            >
                              {item?.status == "Expired Payment Link"
                                ? "Expired"
                                : item?.status == "completed"
                                  ? "Approved"
                                  : item?.status == "requested"
                                    ? "Processing"
                                    : startCase(item?.status)}
                            </div>
                          </div>
                          <div
                            _ngcontent-serverapp-c3748548866
                            className="list-field time ng-tns-c3748548866-17"
                          >
                            {moment(item?.createdAt).format("HH:MM:SS")}
                          </div>
                          <div
                            _ngcontent-serverapp-c3748548866
                            className="list-arrow ng-tns-c3748548866-17 ng-star-inserted"
                            style={{
                              "mask-image":
                                'url("/assets/Other/icon-arrow-type01.svg")',
                            }}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })
          ) : (
            <NoData />
          )}

          <div
            _ngcontent-serverapp-c3748548866
            className="prompt ng-tns-c3748548866-17 ng-star-inserted"
            style={{ "margin-top": "20px" }}
          >
            {" "}
            －end of page－{" "}
          </div>

          <div
            _ngcontent-serverapp-c302379289
            style={{ height: "10px", visibility: "hidden" }}
          >
            {" "}
            anchor{" "}
          </div>
        </app-waterfall-scroll>
      </div>

      {!isEmpty(detail) && (
        <TransactionRecordDetail detail={detail} setDetail={setDetail} />
      )}
    </AccountLayout>
  );
};

export default TransactionRecords;
